import { colors } from "../Styles";

  // Color on progress bar/circle etc.
  export const progressColor = (percentage: number) => {
    if (percentage <= 25) return colors.graphBlueFive; // Under 50%
    if (percentage >= 75) return colors.graphBlueEleven; // Over 75%
    return colors.graphBlueEight; // Between 50% and 75%
  };